import DrawableCircle from 'classes/DrawableCircle';
import MovingCircle from 'classes/MovingCircle';
import * as helpers from 'helpers';

class CircleFactory {
  MAX_RADIUS = 5;

  getRandomCircle = (maxX, maxY) => {
    const radius = helpers.getRandomIntegerBetween(1, this.MAX_RADIUS);
    return new DrawableCircle(
      helpers.getRandomIntegerBetween(radius, maxX),
      helpers.getRandomIntegerBetween(radius, maxY),
      radius,
      helpers.getRandomRGBColor()
    );
  };

  getRandomMovingCircle = (maxX, maxY) => {
    const circle = this.getRandomCircle(maxX, maxY);
    const velocityVector = helpers.getRandomVelocityVector();
    return new MovingCircle(circle, velocityVector);
  };

  getCircle = (
    centerX,
    centerY,
    radius = helpers.getRandomIntegerBetween(1, this.MAX_RADIUS),
    color = helpers.getRandomRGBColor(),
    velocityVector = helpers.getRandomVelocityVector()
  ) => {
    const circle = new DrawableCircle(
      centerX,
      centerY,
      radius,
      color,
    );
    return new MovingCircle(circle, velocityVector);
  }
}

export default CircleFactory;



// WEBPACK FOOTER //
// ./src/classes/CircleFactory/index.js